module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/news.7f5a1ac8.svg";